import { useLocation, useNavigate } from "react-router-dom";
import { designerReturnState } from "../builder/designerReturn";
import { PageBarViewActionsProps } from "./PageBarViewActions.types";

/**
 * New view, Duplicate view and Manage views, above the record's own actions in the
 * kebab menu. The first two open the designer on something unsaved, so an abandoned
 * view leaves no trace; Manage views opens it on the default.
 */
export function PageBarViewActions({
  pagePath,
  formId,
  onNavigate,
}: PageBarViewActionsProps) {
  const location = useLocation();
  const navigate = useNavigate();

  // No search names no view, so the designer opens on the default.
  const open = (search = "") => {
    onNavigate();
    navigate(`/manage-views${pagePath}${search && `?${search}`}`, {
      state: designerReturnState(location),
    });
  };

  return (
    <>
      <button
        className="header-bar-menu-item"
        onClick={() => open("new=1")}
      >
        New view
      </button>
      <button
        className="header-bar-menu-item"
        onClick={() => open(`duplicate=${encodeURIComponent(formId)}`)}
      >
        Duplicate view
      </button>
      <button className="header-bar-menu-item" onClick={() => open()}>
        Manage views
      </button>
    </>
  );
}

export default PageBarViewActions;
